import { Icon } from "@/client/ui/Icon";
import { SpeechBubble } from "@/client/ui/SpeechBubble";
import { useState } from "react";
import { Text } from "@/client/ui/Text";
import {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { PylymarkTypewriter } from "./PylymarkTypewriter";
import { ReanimatedPressable } from "./ReanimatedPressable";

export const TutorialDialogBox = ({
  text,
  onContinue,
}: {
  text: string;
  onContinue: () => void;
}) => {
  const [speechBubbleLoaded, setSpeechBubbleLoaded] = useState(false);
  const [typewriterCompleted, setTypewriterCompleted] = useState(false);
  const [fastForward, setFastForward] = useState(false);

  // Entering animation timeline (0 to 1). This faciliates delaying the entering
  // animation until the assets have been loaded.
  const enteringTimelineSv = useSharedValue(0);

  const animatedContentStyle = useAnimatedStyle(() => {
    return {
      transform: [
        { translateX: interpolate(enteringTimelineSv.get(), [0, 1], [-20, 0]) },
      ],
    };
  });

  const handlePress = () => {
    if (typewriterCompleted) {
      onContinue();
    } else {
      setFastForward(true);
      setTypewriterCompleted(true);
    }
  };

  return (
    <ReanimatedPressable
      style={[animatedContentStyle]}
      className="py-[14px] pr-[18px] pl-8"
      onPress={handlePress}
    >
      <Text className={`pyly-body relative`}>
        {speechBubbleLoaded ? (
          <PylymarkTypewriter
            source={text}
            fastForward={fastForward}
            delay={500}
            onAnimateEnd={() => {
              setTypewriterCompleted(true);
            }}
          />
        ) : null}
        {/* Reserve some space for the "Next" chevron icon, so that it doesn't overlap the content of the text. */}
        <Text className="inline-block w-6"></Text>

        <Icon
          icon="chevron-right"
          size={24}
          className={`
            absolute right-[-6px] bottom-0 animate-hoscillate transition-opacity duration-300

            ${typewriterCompleted ? `opacity-100` : `pointer-events-none opacity-0`}
          `}
          tintColorClassName="accent-fg-loud"
        />
      </Text>

      <SpeechBubble
        className="absolute inset-0"
        onLoad={() => {
          enteringTimelineSv.set(
            withTiming(1, {
              easing: Easing.out(Easing.cubic),
              duration: 500,
            }),
          );
          setSpeechBubbleLoaded(true);
        }}
      />
    </ReanimatedPressable>
  );
};
